@if (items().length) {
    <app-table
        [columns]="columns"
        [gridData]="store.data.getNursingAllowances() || { items: [] }"
        [refreshCallback]="store.api.getNursingAllowances"
        [refreshCallbackFragment]="fragment"
        [additionalFilter]="additionalFilter()"
        [defaultSorters]="[{ column: 'careStartDate', direction: 'ASC' }, { column: 'id', direction: 'ASC' }]"
        translatePrefix="nursingAllowance.widgets."
        tableKey="nursingAllowanceDurationWidget"
        [hideCheckboxes]="true"
        [smallButtons]="true"
        [showSearchBar]="false"
        (detailCallback)="openDetail($event)"
    />
}
